"use client";
import React, { ReactNode } from "react";
import { CookiesProvider } from "react-cookie";

const Cookies: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <>
      <CookiesProvider defaultSetOptions={{ path: "/" }}>{children}</CookiesProvider>
    </>
  );
};

export default Cookies;
